import { render, staticRenderFns } from "./TabComercial.vue?vue&type=template&id=052d59ec&"
import script from "./TabComercial.vue?vue&type=script&lang=js&"
export * from "./TabComercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports